import React from 'react'
import Heading from '@/components/Heading'

const RichTextTestimonial = (props) => {
    return (
        <div className="bg-white my-12">
            <div className="border-l-2 border-brightgreen">
                <div className="ml-5">
                    <Heading size="h5" className="text-left max-w-[945px] mx-auto text-darkblue !font-medium leading-[1.8rem]">
                        "{props.content}"
                    </Heading>
                    <div className="mt-6 flex flex-row justify-start items-center gap-4 text-base tracking-[-0.03em] text-darkblue-700">
                        {props.person}
                        {props.position && <><span className="font-bold text-xl text-brightgreen leading-none"> / </span> {props.position}</>} 
                    </div>
                </div>
            </div>
        </div>
    )
  };

export default RichTextTestimonial;
  